import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { GoOrganization } from "react-icons/go"
import {
  MdLogout,
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineSupportAgent,
  MdOutlineTipsAndUpdates,
  MdQuestionMark,
  MdReviews,
  MdUpload,
} from "react-icons/md"
import { PiSubtitles } from "react-icons/pi"
import { AiOutlineAudit, AiOutlineStock } from "react-icons/ai"
import { BsCashCoin } from "react-icons/bs"
import { Modal, notification } from "antd"
import { CloseOutlined } from "@ant-design/icons"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import secureLocalStorage from "react-secure-storage"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { FaUser, FaUserLock, FaUserTie } from "react-icons/fa"
import { SiCoinmarketcap, SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"
import Loader from "components/Common/Loader"
import axios from "axios"

const SidebarContent = props => {
  const ref = useRef()
  const fileInputRef = useRef(null)
  const [loading, setLoading] = useState(false)

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }
  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])
  useEffect(() => {
    const metis = new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const Navigate = useNavigate()

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  const closeMobileSidebar = () => {
    if (window.innerWidth <= 998) {
      document.body.classList.remove("sidebar-enable")
    }
  }

  const portfolioId = secureLocalStorage.getItem("portfolioId")

  const [allCaseStudy, setAllCaseStudy] = useState([])

  async function allCaseStudies() {
    try {
      setLoading(true)
      const response = await axios.get(
        `${ConfigUrl.apiurl}/portfolio/case/study`,
        {
          headers: {
            Authorization: `${portfolioId}`,
          },
        }
      )

      if (response.data.success) {
        secureLocalStorage.setItem("allCaseStudy", response.data.caseStudy)
        setAllCaseStudy(response.data.caseStudy)
      }
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: "error",
        text: "Something went wrong",
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    allCaseStudies()
  }, [])

  async function getUserIP() {
    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()
      return data.ip
    } catch (error) {
      console.error("Failed to get IP address:", error)
      return null
    }
  }
  const getClicks = async (id, service) => {
    const res = axios.post(
      `${ConfigUrl.apiurl}/portfolio/case/service/${id}`,
      {
        ip: await getUserIP(),
        type: 'service',
        login_id: secureLocalStorage.getItem('loginId'),
        portfolioId: secureLocalStorage.getItem('portfolioId'),
        service: service
      },
      {
        headers: {
          Authorization: `${portfolioId}`,
        },
      }
    )
  }

  console.log("allCaseStudy", allCaseStudy, [
                    ...new Map(
                      allCaseStudy.map(item => [item.services, item])
                    ).values(),
                  ])

  return (
    <React.Fragment>
      {loading && <Loader />}
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link
                to={`${ConfigUrl.appurl}welcome${path?.search}`}
                onClick={closeMobileSidebar}
                className=""
              >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Welcome")}</span>
              </Link>
            </li>

            <li >
              <a
                className="has-arrow dropdown-menu1"
                style={{ background: "transparent" }}
                aria-expanded="true"
              >
                <i className="fas fa-list"></i>
                <span>{props.t("Services")}</span>
              </a>
              <ul className="sub-menu">
                {allCaseStudy &&
                  [
                    ...new Map(
                      allCaseStudy.map(item => [item.services, item])
                    ).values(),
                  ].map(item => (
                    <li key={item.id}>
                      <Link
                        onClick={() =>{ getClicks(item?.id , item?.services)}}
                        to={`${ConfigUrl.appurl}casestudy/${item.services}${path?.search}`}
                      >
                        <span className="">{item.services}</span>
                      </Link>
                    </li>
                  ))}
              </ul>
            </li>

            <li>
              <Link
                to={`${ConfigUrl.appurl}whyus${path?.search}`}
                onClick={closeMobileSidebar}
              >
                <i>
                  <GoOrganization />
                </i>
                <span>{props.t("Why Us")}</span>
              </Link>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
